// Configuration settings for the frontend application
import brand from './brand';

// API URL - Use environment variable if available, otherwise default by environment
export const API_URL =
  process.env.VUE_APP_API_URL ||
  (process.env.NODE_ENV === 'production'
    ? 'https://godea-api.up.railway.app/api'
    : 'http://192.168.56.1:8000/api');

// Brand defaults (overridden at runtime by API /api/site-config/public/)
export const APP_NAME = brand.storeName;
export const CURRENCY = brand.currency;
export const CURRENCY_SYMBOL = brand.currencySymbol;

// File upload settings
export const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
